import _ from 'lodash';
import { useMemo, useState } from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';

import { expiryHandlingPropsTypes } from 'common/propTypes';
import TimeSelector from 'common/components/TimeSelector';
import { getTimeValidatorsV2 } from 'common/utils/validators';
import ErrorMesssage from 'v2/common/components/ErrorMessage/index';
import HoverMessage from 'common/components/HoverMessage';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { isCrypto } = ApplicationDomainUtility;

const propTypes = {
  expiryHandling: expiryHandlingPropsTypes.isRequired,
  onChangeExpiryHandling: PropTypes.func.isRequired,
};
const defaultProps = {};

const Positional = (props) => {
  const {
    expiryHandling: { exitTime, exitDaysBefore, legacyClose },
    expiryHandling,
    onChangeExpiryHandling,
  } = props;
  const { errors, control } = useFormContext();
  const [timePickerName] = useState(_.uniqueId('positionalTimePicker-'));

  const onExpiryHandlingChange = (newConfig) => {
    onChangeExpiryHandling({ ...expiryHandling, ...newConfig });
  };

  const renderDayBeforeExpiryOptions = _.map(_.range(0, 60), (day) => (
    <option key={day} value={day}>{day}</option>
  ));

  const calendarSpreadInfo = useMemo(() => (
    <div>
      <b>Calendar Spread (Options{isCrypto ? '' : ' & Futures'}):</b><br />
      The current weekly/monthly expiry will expire in the same week/month, while the next weekly/monthly expiry will carry forward the position and then exit in the following week/month.<br /><br />

      <b>{isCrypto ? 'Futures' : 'Equity'}:</b><br />
      Holds the stock for a longer period or until your defined exit conditions are met.
    </div>
  ), []);

  return (
    <div className="positional-exit-handler mb-4">
      <div className="row align-items-center">
        <div className="col-md-2">
          <label className="label_style">Expiry Handling</label>
        </div>
        <div className="col-md-10 d-flex flex-wrap">
          <div className="input-group d-flex gap-2">
            <Form.Control
              className="form-control positional-control"
              as="select"
              value={exitDaysBefore}
              onChange={(event) => onExpiryHandlingChange({
                exitDaysBefore: parseInt(event.target.value, 10)
              })}
            >
              {renderDayBeforeExpiryOptions}
            </Form.Control>
            <div className="input-group-append">
              <span className="input-group-text">Days Before Expiry</span>
            </div>
            <ErrorMesssage message={errors[timePickerName]?.message || ''}>
              <Controller
                render={({ onChange }) => (
                  <TimeSelector
                    style={timePickerName}
                    onTimeChange={(newExitTime) => {
                      onExpiryHandlingChange({ exitTime: newExitTime });
                      onChange(newExitTime);
                    }}
                    selectedTime={exitTime}
                  />
                )}
                control={control}
                defaultValue={exitTime}
                name={timePickerName}
                rules={getTimeValidatorsV2()}
              />
            </ErrorMesssage>
            <div className="form-check mb-3 d-flex align-items-center">
              <input
                className="form-check-input track"
                type="checkbox"
                id="calendarSpread"
                value={String(legacyClose)}
                tabIndex={-100}
                onChange={() => onExpiryHandlingChange({ legacyClose: !legacyClose })}
                onClick={() => onExpiryHandlingChange({ legacyClose: !legacyClose })}
                checked={legacyClose}
              />
              <label className="form-check-label" htmlFor="calendarSpread" />
              <label className="form-check-label" htmlFor="calendarSpread">
                Calendar Spread
              </label>
              <HoverMessage title="Calendar Spread" message={calendarSpreadInfo}>
                <i className="fa-regular fa-circle-info info-icon ms-2 me-2 mr-2" aria-hidden="true"></i>
              </HoverMessage>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Positional;

Positional.propTypes = propTypes;
Positional.defaultProps = defaultProps;
